import { convertToNumber } from 'utils/converters';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

import useGetRowData from '../hooks/useGetRowData';
import CreateEditSurchargeMaintenanceForm from './CreateEditSurchargesMaintenanceForm';
import { EditSurchargesMaintenanceSkeleton } from './EditSurchargesMaintenanceSkeleton';

export default function CreateEditSurchargesMaintenance({
  handleClose,
  rowId
}: FormComponentProps) {
  const { isFetching, data } = useGetRowData(convertToNumber(rowId));

  return isFetching ? (
    <EditSurchargesMaintenanceSkeleton />
  ) : (
    <CreateEditSurchargeMaintenanceForm
      handleClose={handleClose}
      rowData={data}
    />
  );
}
